<div class="dashboard-expert-container">
  <!-- Header Section -->
  <div class="header-section">
    <span class="current-date">{{ currentDate | date:'fullDate':'':'es-PE' }}</span>
    <h1 class="welcome-title">¡Hola {{ user?.name || 'Marcela' }}!</h1>
    <p class="welcome-subtitle">Bienvenido a tu perfil como experto</p>
  </div>

  <!-- Agenda Update Banner -->
  <div class="agenda-banner">
    <div class="banner-text-content">
      <h3 class="banner-title">Mantén actualizada tu agenda</h3>
      <p class="banner-description">No olvides habilitar tus horarios disponibles en tu agenda.</p>
    </div>
    <button class="btn-enable-hours" (click)="goToAgenda()">Habilitar horarios</button>
  </div>

  
  <!-- Próximas Sesiones Section -->
  <div class="upcoming-sessions-container">

    <div class="section-header">
      <div class="header-content">
        <h2 class="section-title">Próximas sesiones</h2>
        <p class="section-subtitle">Mira la lista de tus próximas sesiones aquí</p>
      </div>
      <button class="btn-view-all" (click)="viewAllSessions()">Ver lista completa</button>
    </div>

    <!-- Table Section -->
    <div class="table-container">
      <table class="sessions-table">
        <thead>
          <tr>
            <th class="sortable" (click)="sortBy('menteeName')">
              Cliente
              <svg class="sort-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </th>
            <th class="sortable" (click)="sortBy('date')">
              Fecha
              <svg class="sort-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </th>
            <th>Hora</th>
            <th>Duración</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let session of paginatedSessions; let i = index" class="session-row">
            <td class="mentee-cell">
              <div class="mentee-info">
                <div class="mentee-avatar">
                  <img [src]="session.menteeAvatar || '/assets/icons/default-avatar.png'" [alt]="session.menteeName" class="avatar-img">
                </div>
                <span class="mentee-name">{{ session.menteeName }}</span>
              </div>
            </td>
            <td class="date-cell">{{ session.date | date:'dd/MM/yyyy' }}</td>
            <td class="time-cell">{{ session.time }}</td>
            <td class="duration-cell">{{ session.duration }} minutos</td>
            <td class="action-cell"><button class="enter-session-btn" (click)="enterSession(session)">Ingresar a sesión</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- Modal de cita -->
  @if (showAppointmentModal && selectedAppointment) {
  <div class="modal-overlay" (click)="closeAppointmentModal()">
    <div class="meeting-modal" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="closeAppointmentModal()">
        <mat-icon>close</mat-icon>
      </button>
      <h2 class="modal-title">Reunión con {{ selectedAppointment.clientName }}</h2>
      <h3 class="meeting-title">Reunión con {{ selectedAppointment.clientName }}</h3>
      <div class="meeting-time">{{ selectedAppointment.time }}</div>
      <div class="meeting-info-section">
        <div class="info-label">ID de reunión:</div>
        <div class="meeting-id">
          <div>{{ getMeetingLink() }}</div>
        </div>
      </div>
      <div class="invitation-message">
        Expertos Phoenix te está invitando a una reunión de Meet programada. Únete a la reunión de Meet con el siguiente link.
      </div>
      <div class="meeting-link-container">
        <div class="meeting-link">
          <mat-icon class="meet-icon">videocam</mat-icon>
          <span>{{ getMeetingLink() }}</span>
        </div>
      </div>
      <div class="modal-actions">
        <button class="btn-join-meeting" (click)="joinMeeting()">
          Unirse a la reunión
        </button>
        <span class="copy-link" (click)="copyMeetingLink()">Copiar enlace</span>
        <button class="btn-send-email" (click)="sendMeetingEmail()">
          <mat-icon>email</mat-icon>
          Enviar por email
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Modal de Alerta -->
  <div class="modal-overlay" *ngIf="showAlertModal" (click)="closeAlertModal()">
    <div class="modal-content alert-modal" (click)="$event.stopPropagation()">
      <!-- Título del modal -->
      <div class="modal-title">
        {{ alertTitle }}
      </div>
      
      <!-- Mensaje del modal -->
      <div class="modal-message">
        {{ alertMessage }}
      </div>
      
      <!-- Botón del modal -->
      <div class="modal-actions">
        <button class="btn-confirm" (click)="closeAlertModal()">
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>

